import styled from "@emotion/styled";

const StyledSpan = styled.span`
  color: ${p =>
    !p.red ? p.theme.colors.secondary.gray : p.theme.colors.error.main};
`;

export default StyledSpan;
